export const telegramHelper = 'https://t.me/Spodial_Support';

export const maxImagesToProductUpload = 20;
